import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
`;

export const FormTitle = styled.h2`
  font-size: ${32 / 16}rem;
  color: rgb(102, 102, 102);
  text-align: center;
  font-weight: bold;
  margin-top: 32px;
`;

export const FormParagraph = styled.p`
  text-align: center;
  color: rgb(102, 102, 102);
  margin-top: 8px;
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  overflow: auto;
  margin-top: 48px;
  gap: 24px;
  max-height: 50vh;
`;

export const FormWrapper = styled.form`
  max-width: 90%;
  margin: auto;
  gap: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ButtonsWrapper = styled.div`
  gap: 16px;
  display: flex;
  justify-content: center;
  min-width: 80%;
`;

export const SignerButtonsWrapper = styled.div`
  gap: 16px;
  display: flex;
  align-items: center;

  & svg {
    min-width: ${24 / 16}rem;
    min-height: ${24 / 16}rem;
  }
`;

export const SignerBtn = styled.button`
  border-radius: 100%;
  width: 36px;
  height: 36px;
  font-weight: 500;
  font-size: ${20 / 16}rem;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  & svg {
    min-width: ${16 / 16}rem;
    min-height: ${16 / 16}rem;
  }
`;

export const AddSignerBtn = styled(SignerBtn)`
  border: 1px solid #00bf33;
  color: #00bf33;
  background-color: #fff;
  svg {
    margin-left: 8px;
  }
`;
export const RemoveSignerBtn = styled(SignerBtn)`
  border: 1px solid ${({ disabled }) => (disabled ? "#dcdcdc" : "#BF0000")};
  color: ${({ disabled }) => (disabled ? "#a0a0a0" : "#BF0000")};
  background-color: ${({ disabled }) => (disabled ? "#f0f0f0" : "#fff")};
  svg {
    margin-left: 8px;
  }
`;
export const StepBtn = styled.button`
  width: 35%;
  border-radius: 2rem;
  padding: 12px;
  font-weight: 500;
  font-size: ${14 / 16}rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  & svg {
    min-width: ${16 / 16}rem;
    min-height: ${16 / 16}rem;
  }
`;

export const BackBtn = styled(StepBtn)`
  border: 1px solid #b6b6b6;
  color: #606060;
`;
export const ForwardBtn = styled(StepBtn)`
  border: 1px solid #6ea6ff;
  color: #fff;
  background-color: #6ea6ff;
  svg {
    margin-left: 8px;
  }
`;

export const AttachFileButton = styled.div`
  min-width: 35%;
  > label {
    font-weight: 500;
    color: #606060;
    border-radius: 2rem;
    font-size: ${14 / 16}rem;
    padding: 0.5rem;
    border: 1px solid #b6b6b6;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5%;

    &#add-file-lbl {
      cursor: pointer;
    }
  }

  > label#file-name-lbl {
    padding: 0.75rem 1.5rem;
    min-width: 40%;

    > span {
      display: flex;
      align-items: center;
      justify-content: space-between;

      > h6 {
        cursor: pointer;
        font-size: 1rem;
        color: #3241c1;
        font-weight: 600;
      }
      > h6:hover {
        opacity: 0.7;
        transition: linear 0.1s;
      }

      > svg {
        cursor: pointer;
      }
    }
  }

  input[type="file"] {
    display: none;
  }
`;

export const FilesCheckWrapper = styled.div``;

export const FileChecked = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  > p {
    font-size: 13px;

    margin-left: 8px;
  }

  > button {
    background: transparent;

    border: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-left: 18px;
  }
`;
